module.exports = __webpack_public_path__ + "static/bingeplaceholder_noimage-v1-02c831f6db7f5932fe03ea25da7ad32d.png";